// NPM
/* Load npm scripts here */
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { withFocusManagement } from 'helpers/swiper/swiperFocusManagement';

// VENDOR
/* Load vendor modules here */

// BUNDLES
/* Load bundles here */
import defaultBundle from 'bundles/default.bundle';
// HELPERS
/* Load helpers here */
import { initFiltering } from 'helpers/filters/filters';
import { wishlistHandler } from 'helpers/wishlist/wishlist';

// COMPONENTS
/* Load components here */
import { attributeInfoPopup } from 'components/attribute-info-popup/attributeInfoPopup';
import ReadMore from 'components/readmore/readMore';

// PAGE
/* load page specific scripts */
import GtmCategorySubEvents from './partials/gtmSubCategory';
import { GuidedSelling } from './partials/guided-selling';
import { AlertB2BPricing } from './partials/alert-b2b-pricing';
import { CategoriesMenuHandler } from '../../helpers/categories/categories-menu';
import { handleKhLinks } from './partials/handle-kh-links';
import { filterImageSlider } from './partials/images';

defaultBundle();

// Init filters
initFiltering({
    filterType: 'category'
});

// Init GTM
GtmCategorySubEvents.init();

// The configurator pulls in the zod + libphonenumber validation stack, so it is
// only fetched on categories that actually render one
if (document.querySelector('.product-configurator')) {
    import('./partials/productConfigurator').then(({ ProductConfigurator }) => {
        ProductConfigurator.init();
    });
}

// Init wishlist add/remove product handler
wishlistHandler.init();

// Init category link block swiper
const linkBlockSwiperEl = document.querySelector('.link-block-swiper');
if (linkBlockSwiperEl) {
    const swiperConfig = withFocusManagement({
        modules: [Navigation],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        spaceBetween: 16,
        slidesPerView: 'auto'
    });

    // config for image-slider
    if (linkBlockSwiperEl.classList.contains('has-images')) {
        swiperConfig.breakpoints = {
            768: {
                slidesPerView: 4
            },
            1200: {
                slidesPerView: 5
            },
            1550: {
                slidesPerView: 6
            }
        };
    }

    new Swiper(linkBlockSwiperEl, swiperConfig);
}

// Init read more button
ReadMore.init();
// Init filter info popups
attributeInfoPopup.init();
// Init Guided selling component
GuidedSelling.init();
// B2B Pricing alert
AlertB2BPricing.init();
// CategorieMenuHandler
CategoriesMenuHandler.init();

handleKhLinks.init();

filterImageSlider();
